<mat-toolbar class="mat-elevation-z4">
  <div class="header">
    <div
      class="header__logo"
      [ngClass]="{ 'header__logo--pointer': !disableNavigationBtns }"
      (click)="!disableNavigationBtns && onNavigationBtnClick('/')"
    >
      <img src="../../../../../assets/images/logo-login.png" />
    </div>
    <div class="header__nav" *ngIf="visibleActions">
      <!-- List of navigation buttons -->
      <ng-container *ngFor="let navItem of navigationButtons">
        <button
          [ngClass]="{
            'header__nav--active':
              _layout.activeLocationSignal() == navItem.location
          }"
          class="header__link"
          [disabled]="disableNavigationBtns"
          (click)="onNavigationBtnClick(navItem.location)"
        >
          {{ navItem.translation | transloco | uppercase }}
        </button>
      </ng-container>
    </div>
    <div class="dropdown-icon-btn" *ngIf="visibleActions">
      <button
        [matMenuTriggerFor]="menu"
        #menuTrigger="matMenuTrigger"
        (click)="openMenu(); rotate()"
        [@rotate]="rotationIconSignal() ? 'initial' : 'final'"
        mat-icon-button
      >
        <mat-icon>menu</mat-icon>
      </button>
      <button
        [ngClass]="{ 'active-btn': !rotationIconSignal() }"
        (click)="closeMenu()"
        [@rotate]="rotationIconSignal() ? 'finalReverse' : 'initialReverse'"
        mat-icon-button
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="header__action" *ngIf="visibleActions">
      <ng-container *ngIf="!disableNavigationBtns">
        <app-logo></app-logo>
      </ng-container>
      <app-button
        buttonType="secondary"
        text="{{ 'layout.logout' | transloco }}"
        (click)="logout()"
      ></app-button>
    </div>
  </div>
</mat-toolbar>

<mat-menu (closed)="rotate()" #menu="matMenu" yPosition="below">
  <ng-container *ngIf="!disableNavigationBtns">
    <app-logo [verticalPosition]="true"></app-logo>
  </ng-container>
  <mat-divider></mat-divider>

  <!-- Dropdown navigation buttons -->
  <ng-container *ngFor="let navItem of navigationButtons">
    <button
      class="text--bolder"
      mat-menu-item
      (click)="onNavigationBtnClick(navItem.location)"
    >
      {{ navItem.translation | transloco }}
    </button>

    <mat-divider></mat-divider>
  </ng-container>

  <button class="text--bolder text--accent" mat-menu-item (click)="logout()">
    {{ "layout.logout" | transloco }}
  </button>
</mat-menu>
